module.exports = __webpack_public_path__ + "static/media/C4-Email.8916d6cb.svg";